<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "专利分解" : "专利分解" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='650'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-card v-for="(item, idx) in form.patents" :key="idx" class="mb-3" outlined>
                <v-card-title>专利NO.{{idx+1}}</v-card-title>
                <v-card-text>
                    <v-row >
                        <v-col cols="12" md="12">
                          <v-text-field
                            hide-details="auto"
                            :key='idx'
                            label="专利名称（未确定可先填‘无’）"
                            outlined
                            :rules="required"
                            v-model="form.patents[idx].name">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                              hide-details="auto"
                              outlined
                              v-model="form.patents[idx].patentType"
                              :rules="required"
                              :items="patentTypeItem"
                              item-text="label"
                              item-value="value"
                              label="专利类型"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-text-field
                            hide-details="auto"
                            :key='idx'
                            label="申请人"
                            outlined
                            :rules="required"
                            v-model="form.patents[idx].applyUser">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                hide-details="auto"
                                :key='idx'
                                label="第一发明人姓名"
                                outlined
                                v-model="form.patents[idx].firstInventorName">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field
                                hide-details="auto"
                                :key='idx'
                                label="第一发明人身份证"
                                outlined
                                v-model="form.patents[idx].firstInventorCard">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-text-field
                                :key='idx'
                                label="其他发明人姓名,多个以逗号分割"
                                outlined
                                hide-details="auto"
                                v-model="form.patents[idx].otherInventorName">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { isEmpty } from '@/utils/stringUtil.js'
  import { selectNextYear } from '@/utils/tool.js'
  import { decp } from '@/api/patent/index.js'

  export default {
    name: 'OrderDecpEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        patentTypeItem: [
          { label: '实用新型', value: 1 },
          { label: '发明专利', value: 2 },
          { label: '外观专利', value: 3 }
        ],
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        yearItems: selectNextYear(),
        form: {
          orderId: '',
          contractId: '',
          customerId: '',
          patents: [
            {
              name: '',
              year: '',
              applyUser: '',
              patentType: '',
              firstInventorName: '',
              otherInventorName: '',
              firstInventorCard: ''
            }
          ]
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          decp(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      patentNumberInput (val, applyUser) {
        this.form.patents = []
        for (let i = 0; i < Number(val); i++) {
          this.form.patents.push({ name: '', applyUser: applyUser })
        }
      },
      dialogChange (val) {
        this.reset()
        this.item.show = val
        if (val && this.isEdit) {
            this.form.orderId = this.item.data.id
            this.form.contractId = this.item.data.contract.id
            this.form.customerId = this.item.data.customer.id
            this.patentNumberInput(this.item.data.contract.productNumber, this.item.data.customer.name)
        }
      },
      reset () {
        if (!isEmpty(this.$refs.form)) {
          this.$refs.form.reset()
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
